import React, { useState } from "react";
import _ from "lodash";
import Form from "forms/Form";
import formWrapper from "hoc/formWrapper";

const ConfirmLoginForm = ({ qrCodeSource, onVerified, modal, danger, onRequestClose, apiEndpoint, onSubmitClicked }) => {
    const [defaultValues, setDefaultValues] = useState({});
    const endpoint = apiEndpoint || `complete-login`;

    const onChange = (key, value) => {
        setDefaultValues({
            ...defaultValues,
            [key]: value
        });
    }

    const getValue = (name) => {

        const value = !_.isEmpty(defaultValues) ? defaultValues[name] : null;
        return value;
    };

    const onSubmit = (data) => {
        if (data?.is_valid) {
            onVerified(true)
        }
        if (onSubmitClicked) {
            onSubmitClicked(data)
        }
    }

    const fields = 1
        ? [
            {
                elementType: "input",
                id: "one_time_password",
                name: "one_time_password",
                labelText: "Insert your one time password",
                placeholder: "One time password",
                value: getValue("one_time_password"),
                rules: {
                    required: true,
                },
            }
        ]
        : [];

    const extraContents = qrCodeSource ? (
        <div>
            <div dangerouslySetInnerHTML={{
                __html: qrCodeSource
            }} />
        </div>
    ) : null

    return (
        <>
            <Form
                fields={fields}
                endpoint={endpoint}
                isLogin={true}
                // method={"put"}
                modal={modal}
                danger={danger}
                loaded={true}
                blockTouched={true}
                onChange={(name, value) => onChange(name, value)}
                onSubmit={(evtData) => onSubmit(evtData)}
                onRequestClose={onRequestClose}
                afterPostOKMessage={"Login succeded!"}
                afterPostKOMessage={"Something was wrong"}
                postingMessage={"Please wait..."}
                extraContents={extraContents}
                hasStandardFooter
            />
        </>

    );
};

export default ConfirmLoginForm;

export const WrappedConfirmLoginForm = formWrapper(ConfirmLoginForm)
